import React from 'react';
import { loginView as LoginView } from './loginView';
import { fetch } from '../../modules/httpServices';
import APP from '../../modules/index';
import { cloneDeep } from 'lodash';
import '../../css/login.css';

class LoginComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      errorMessage: '',
      isLoading: false
    };
  }

  onSubmit = (event) => {
    event.preventDefault();
    this.setState({ isLoading: true }, () => {
      const { email, password } = this.state;
      fetch.post({
        url: APP.Constants.SERVICE_URLS.LOGIN,
        requestBody: {
          password,
          email
        },
        callbackHandler: this.loginSubmitSuccess
      });
    });
  };

  loginSubmitSuccess = (response) => {
    const { status, payload } = response;
    const _state = cloneDeep(this.state);
    _state.isLoading = false;
    if (status === APP.Constants.SUCCESS) {
      if (payload.message === 'User was expired.Please Contact Xebia Admin') {
        _state.errorMessage = 'User has expired Please Contact Xebia Admin';
      } else {
        _state.errorMessage = '';
        localStorage.setItem('Token', payload.token);
        localStorage.setItem('TestDataManagement', payload.testDataManagement);
        localStorage.setItem('TestDesign', payload.testDesign);
        localStorage.setItem(
          'role',
          payload.email === 'admin@xebia.com' ? 'SUPERADMIN' : 'ADMIN'
        );
        localStorage.setItem('userid', payload.id);
        localStorage.setItem('is_Internal', payload.is_Internal);
        localStorage.setItem(
          'customerName',payload.customerName
        );
        localStorage.setItem('firstname', payload.firstname);
        localStorage.setItem('projectManagement', payload.projectManagement);
        localStorage.setItem('email', payload.email);
        localStorage.setItem('lastLogin', payload.lastLoginDate);
        localStorage.setItem(
          'username',
          payload.firstname + ' ' + payload.lastname
        );
        if (this.props?.history?.location?.search) {
          const queryString = window.location.search; // e.g. "?param=ace.xebia.com"
          const params = new URLSearchParams(queryString);
          const paramValue = params.get('path');
          window.location.href = `${paramValue}?user=${payload.firstname}`;
          return; // prevent further code execution
        }
        if (payload && payload.email === 'admin@xebia.com') {
          this.props.goToPage(APP.Constants.ROUTES.SUPER_ADMIN);
        } else if (payload.testDataManagement && payload.testDesign) {
          this.props.goToPage(APP.Constants.ROUTES.HOME);
        } else if (payload.testDataManagement) {
          sessionStorage.setItem('TestCheck', 'TestData');
          this.props.goToPage(APP.Constants.ROUTES.DESIGN_HOME);
        } else {
          sessionStorage.setItem('TestCheck', 'TestDesign');
          this.props.goToPage(APP.Constants.ROUTES.DESIGN_HOME);
        }
      }
    } else {
      _state.errorMessage = 'Email or Password is incorrect';
    }

    this.setState(_state);
  };

  onChange = (event) => {
    const { value, name } = event.currentTarget;
    this.setState({ [name]: value });
  };

  render() {
    return (
      <LoginView
        {...{
          ...this.state,
          onChange: this.onChange,
          onSubmit: this.onSubmit
        }}
      />
    );
  }
}

export default LoginComponent;
